module.exports = __webpack_public_path__ + "static/media/vaisala.a2665688.jpg";